export default __webpack_public_path__ + "static/media/hht2_ep08_timeline_04.dca98ab9.png";